module.exports = __webpack_public_path__ + "img/xbox.bf33f0e6.svg";